import React, { useMemo, useState } from 'react';
import './OtpInput.css';
import { RE_DIGIT } from '../data/constants';

const OtpInputBox = ({ value, valueLength, onChange }) => {
    const valueItems = useMemo(() => {
        const valueArray = value.split('');
        const items = [];
        for (let i = 0; i < valueLength; i++) {
            const char = valueArray[i];
            if (RE_DIGIT.test(char)) {
                items.push(char);
            } else {
                items.push('');
            }
        }
        return items;
    }, [value, valueLength]);
    const inputOnChange = (e, idx) => {
        const target = e.target;
        const targetValue = target.value;
        if (!RE_DIGIT.test(targetValue)) {
            return;
        }
        const newValue =
            value.substring(0, idx) + targetValue + value.substring(idx + 1);
        onChange(newValue);
        const nextElementSibling = target.nextElementSibling;
        if (nextElementSibling) {
            nextElementSibling.focus();
        }
    };
    return (
        <div className="otp-group">
            {valueItems.map((digit, idx) => (
                <input
                    key={idx}
                    type="text"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    pattern="\d{1}"
                    maxLength={valueLength}
                    className="otp-input"
                    onChange={(e) => inputOnChange(e, idx)}
                    value={digit}
                />
            ))}
        </div>
    )
}

export default OtpInputBox;